module.exports = __webpack_public_path__ + "img/verified-white.268b48c0.svg";